export enum PresentsTabsEnums {
  profile = 'profile',
  presents = 'presents',
  stores = 'stores'
}

export enum InvitationsTabsEnums {
  boys = 'boys',
  girls = 'girls'
}
